import { Form, Input, FormContext } from 'dash-ui';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { FormFields } from 'containers/properties/PropertyInventory/components/AddPropertyInventoryModal/constants/constants';
import useValidation from 'containers/properties/PropertyInventory/components/AddPropertyInventoryModal/hooks/useValidation';

const NameRow = () => {
  const { t } = useTranslation(['forms', 'common', 'pages']);
  const { formState, formErrors, stateHandlers } = useContext(FormContext);
  const valid = useValidation();

  const onChange = (fieldName: FormFields) => (value: number | string) => {
    stateHandlers[fieldName](value);
    valid(fieldName, value.toString());
  };

  return (
    <Form.Group w="100%" mt={2}>
      <Form.Label required>{t('forms:labels.name')}</Form.Label>
      <Input
        w="100%"
        value={formState.name || ''}
        placeholder={t('forms:placeholders.inventoryName') || ''}
        onChange={(e) => onChange(FormFields.Name)(e.target.value)}
        $errorType={formErrors[FormFields.Name]?.type}
      />
      <Form.Feedback $errorType={formErrors[FormFields.Name]?.type}>
        {formErrors[FormFields.Name]?.message}
      </Form.Feedback>
    </Form.Group>
  );
};

export default NameRow;
